import { ecsApi } from '@services';
import { CreateBtpCardDeliveryPayload, CreateBtpCardDeliveryResponse } from './btpCard.types';

export const btpCardApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        createBtpCardDelivery: builder.mutation<CreateBtpCardDeliveryResponse, CreateBtpCardDeliveryPayload>({
            query: (payload) => ({
                url: '/btp-card/deliveries',
                method: 'POST',
                body: payload
            })
        })
    })
});

export const { useCreateBtpCardDeliveryMutation } = btpCardApi;
